@if (imageUrls().length > 0) {
  <div class="rn-image-gallery">
    @for (url of imageUrls(); track url) {
      <button type="button" class="rn-image-gallery__item" (click)="open(url)">
        <img [src]="url" alt="" class="rn-image-gallery__img" />
      </button>
    }
  </div>
}

@if (lightboxUrl(); as url) {
  <div class="rn-lightbox" role="dialog" aria-modal="true" (click)="close()">
    <button type="button" class="rn-lightbox__close" aria-label="Close preview" (click)="close()">
      <app-admin-icon name="x" [size]="24" />
    </button>
    <img [src]="url" alt="" class="rn-lightbox__img" (click)="$event.stopPropagation()" />
  </div>
}
